import React from "react";
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";
import "./EditProfile.scss";
import Api from "../../Common/api.jsx";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import MetaMaskService from "../../Common/metamaskService.jsx";
import { Navigate } from "react-router-dom";
import { notifications } from "../../Helpers/Notifications";
import { ToastContainer } from "react-toastify";

export default class EditProfile extends React.Component {
  constructor(props) {
    super(props);
    this.dName=''
    this.profileImgName=''
    this.bannerImageName=''
    //this.formValid;
    this.state = {
      filter: "",
      userUpdateProfileArray: [],
      id: null,
      image: null,
      cropData: "#",
      cropper: null,
      preview: false,
      user_name: '',
      bio: '',
      custom_url: '',
      twitter_profile: '',
      personal_website: '',
      profile_picture: '',
      banner_picture: null,
      user_id: '',
      email: '',
      redirectToUserProfile: false,

      bannerImage: null,
      bannerCropData: "#",
      bannerCropper: null,
      bannerPreview: false,

      isError: {
        displayName: '',
        profile:'',
        banner:'',
    },
    isSaving:false,
    openPopup: false,
    };
  }
  handleClick () {
    this.refs['bImage'].click();
    //inputRef.current.click();
  };
  handlePImage() {
    this.refs['pImage'].click();
    //inputRef.current.click();
  };
  async componentDidMount() {
    window.addEventListener('click', () => { document.getElementsByClassName("search-autocomplete")[0].style.display="none" });
    let account = await new MetaMaskService().getAccount();
    this.getUserProfile(account);
  }

  togglePopup(value) {
    this.setState({ openPopup: value });
  }

  getUserProfile(account) {
    const api = new Api();
    var parameter = "";
    api
      .get("get_user/?account=" + account)
      .then((response) => {
        this.setState({
          user_name: response.data.user_name,
          user_id: response.data.user_id,
          bio: response.data.bio,
          // custom_url: response.data.custom_url,
          twitter_profile: response.data.twitter_profile,
          personal_website: response.data.personal_website,
          profile_picture: response.data.profile_picture,
          banner_picture: response.data.bannerCropData,
          email: response.data.email,
        });
      })
      .catch((err) => console.log(err));
  }

  handleChange(e) {
    console.log(e, e.target.name);
    this.setState({ [e.target.name]: e.target.value });
    this.formValChange(e);
   // console.log(this.state);
  }

  updateUserProfile() {
    const api = new Api();
    this.setState({ isSaving: true });
    const obj = {
      user_name: this.state.user_name,
      user_id: this.state.user_id,
      bio: this.state.bio,
      // custom_url: this.state.custom_url,
      twitter_profile: this.state.twitter_profile,
      personal_website: this.state.personal_website,
      profile_picture: this.state.profile_picture,
      banner_picture:
        this.state.bannerCropData != "#"
          ? this.state.bannerCropData
          : null,
      email: this.state.email,
    };
  
    api
      .post("update_user/", obj)
      .then((response) => {
        notifications.success("Profile updated successfully");
        this.setState({ openPopup: true, isSaving: false });
        const timer = setTimeout(() => {
          this.setState({ redirectToUserProfile: true });
        }, 1000);
      })
      .catch((err) => console.log(err));
  }

  onChangeFun(e, forImage) {
    let t = this;
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    const reader = new FileReader();
    reader.onload = () => {
      if (forImage == "collection") {
        this.setState({ image: reader.result });
        this.setState({ preview: true });
      } else {
        this.setState({ bannerImage: reader.result });
        this.setState({ bannerPreview: true });
      }
    };
    reader.readAsDataURL(files[0]);
    if(forImage == "collection"){
      this.clearCropdata("collection");
    }else{
      this.clearCropdata("bannerImage");
    }
  }

  getCropData(forImage) {
    this.setState({ preview: false });
    if (typeof this.state.cropper !== "undefined" && forImage == "collection") {
      this.setState({
        profile_picture: this.state.cropper.getCroppedCanvas().toDataURL(),
      });
      console.log(this.state);
    } else if (
      typeof this.state.bannerCropper !== "undefined" &&
      forImage == "bannerImage"
    ) {
      this.setState({
        bannerCropData: this.state.bannerCropper.getCroppedCanvas().toDataURL(),
      });
    }
  }

  onCropperInit(instance, forImage) {
    if (forImage == "collection") {
      this.setState({ cropper: instance });
    } else {
      this.setState({ bannerCropper: instance });
    }
  }

  clearCropdata(forImage) {
    if (forImage == "collection") {
      this.setState({ preview: false });
      this.setState({ cropData: "#" });
      this.setState({ image: null });
    } else {
      this.setState({ bannerPreview: false });
      this.setState({ bannerCropData: "#" });
      this.setState({ bannerImage: null });
    }
  }

  formValid ({ isError, ...rest }) {
    let isValid = false;
    if(this.dName=='' || this.profileImgName=='' || this.bannerImageName==''){
      isValid=true
    }
    if(this.state.user_name=='' || this.state.profile_picture=='' || this.state.banner_picture==''){
      isValid=false
    }
    return isValid;
    // Object.values(isError).forEach(val => {
    //     if (val.length > 0) {
    //         isValid = true
    //     } else {
    //         isValid = false
    //     }
    // });
    // Object.values(rest).forEach(val => {
    //     if (val === null) {
    //         isValid = false
    //     } else {
    //         isValid = true
    //     }
    // });
    // return isValid;
};
  onSubmit = e => {
    this.formValChange({target:{name:'user_name',value:this.state.user_name}})
    this.formValChange({target:{name:'collection',value:this.state.profile_picture ? '1' : '0'}})
    this.formValChange({target:{name:'banner',value:this.state.banner_picture ? '1' : '0'}})
    console.log(this.state.bannerCropData)
    if(this.state.bannerCropData == '#' || this.state.bannerCropData == ''){
      this.bannerImageName=  "Banner image is required";
    }else{
      this.bannerImageName=''
    }
    if (this.formValid(this.state) && this.state.bannerCropData != '#') {
        this.updateUserProfile()
    } else {
        console.log("Form is invalid!");
        //this.createCollectionFun()
        //this.formValChange(e)
    }
};

  formValChange (e) {
   // e.preventDefault();
    const { name, value } = e.target;
    console.log(name,value)
    let isError = { ...this.state.isError };
    switch (name) {
        case "user_name":
            this.dName= value.length == 0 ? "Name is required" : "";
           // this.state.isError.dName = value.length == 0 ? "Name is required" : "";
            break;
        case "collection":
          this.profileImgName= value == 0 ? "image is required" : "";
         // this.state.isError.cImageName =value == 0 ? "image is required" : "";
          break;
        case "banner":
          this.bannerImageName= value == 0 ? "Banner image is required" : "";
         // this.state.isError.bannerImageName =value == 0 ? "Banner image is required" : "";
        break;
        default:
            break;
    }
    this.setState({
        isError,
        [name]: value
    })
    console.log(this.state.isError)
};


  render = () => {
    // if (this.state.redirectToUserProfile) {
    //   return <Navigate to={"/UserProfile"} />;
    // }
    return (
      <>
        <ToastContainer pauseOnFocusLoss draggable pauseOnHover />
        <Header />
        <section className="edit-profile">
          <div className="container">
            <div className="edit-profile__form-wrapper">
              <div className="section-title">
                <h2>EDIT PROFILE</h2>
              </div>
              <div className="edit-profile__img">
              <span className="spanImage_Profile1">Profile Image</span>
                <div className="edit-profile__img-circle"
                  style={{display:this.state.preview == true ? "none" : "block"}}>
                  <img onClick={(e) => this.handlePImage(e)} src={this.state.profile_picture} alt="profileimage" />
                </div>
                <div
                  className="edit-profile__img-upload"
                  style={{
                    display: this.state.preview == false && !this.state.profile_picture ? "block" : "none",
                  }}
                >
                  <i className="material-icons-outlined">upload_file</i>
                  <h3>Upload a new profile picture</h3>
                  <p>Drag or choose your file to upload</p>
                  <p>(JPG, PNG, GIF, at least 300 x 300 px, max 5 Mb.)</p>
                  <input
                    type="file"
                    ref="pImage"
                    accept="image/*"
                    onChange={(e) => {this.onChangeFun(e, "collection");
                    }}
                  />
                </div>
                <Cropper
                  style={{
                    height: 400,
                    width: "100%",
                    display:
                      this.state.cropData == "#" && this.state.preview == true
                        ? "block"
                        : "none",
                  }}
                  zoomTo={0.5}
                  zoomable={false}
                  initialAspectRatio={1}
                  preview=".img-preview"
                  src={this.state.image}
                  viewMode={1}
                  cropBoxResizable={false}
                  minCropBoxHeight={5}
                  minCropBoxWidth={10}
                  background={false}
                  responsive={true}
                  autoCropArea={1}
                  checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
                  onInitialized={(instance) => {
                    //setCropper(instance);
                    this.onCropperInit(instance, "collection");
                  }}
                  guides={true}
                />
                <h1
                  style={{
                    marginTop: 20 + "px",
                    display: this.state.image ? "block" : "none",
                  }}
                >
                  {this.state.preview ? <a 
                    className="button"
                    onClick={() => [this.getCropData("collection"),this.formValChange({target:{name:'collection',value:'1'}})]}
                  >
                    Crop Image
                  </a> : ''}
                  &nbsp;&nbsp;&nbsp;
                  {this.state.preview ? <a
                    className="button"
                    onClick={() => this.clearCropdata("collection")}//,this.formValChange({target:{name:'collection',value:'0'}})]}
                  >
                    Reset
                  </a >: ''}
                </h1>
                <p className="error">
                          {this.profileImgName}
                      </p> 

                <span className="spanImage_Banner">Banner Image</span>
                <span className="spanRecommended-banner">
                  1400x350 px recommended
                </span>
                <div
                  style={{
                    display:
                      this.state.bannerPreview == false ? "block" : "none",
                  }}
                  className="edit-banner__img-upload"
                >
                  <i className="material-icons-outlined">upload_file</i>
                  <input ref="bImage"
                    type="file"
                     accept="image/*"
                    onChange={(e) => {this.onChangeFun(e, "bannerImage");
                    }}
                  />
                </div>
                <div
                  style={{
                    display:
                      this.state.bannerPreview == true &&
                      this.state.bannerCropData != "#"
                        ? "block"
                        : "none",
                  }}
                  className="edit-banner__img-upload1"
                >
                  <img onClick={(e) => this.handleClick()}
                    style={{ width: 400 + "px", height: 200 +'px', marginRight: 10 +"px"}}
                    src={this.state.bannerCropData}
                  />
                </div>

                <Cropper
                  style={{
                    height: 400,
                    width: "100%", //"400px",
                    display:
                      this.state.bannerCropData == "#" &&
                      this.state.bannerPreview == true
                        ? "block"
                        : "none",
                  }}
                  zoomTo={0.5}
                  zoomable={false}
                  initialAspectRatio={1}
                  preview=".img-preview"
                  src={this.state.bannerImage}
                  viewMode={1}
                  cropBoxResizable={false}
                  minCropBoxHeight={350}
                  minCropBoxWidth={1400}
                  background={false}
                  responsive={true}
                  autoCropArea={1}
                  checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
                  onInitialized={(instance) => {
                    this.onCropperInit(instance, "bannerImage");
                  }}
                  guides={true}
                />
                <h1
                  style={{
                    marginTop: 20 + "px",
                    marginRight: 89 + "px",
                    display: this.state.bannerImage ? "block" : "none",
                  }}
                >
                  <a style={{
                    display:
                      this.state.bannerPreview == true &&  this.state.bannerCropData != "#"
                        ? "none"
                        : "inline-flex",
                  }}
                    className="button"
                    onClick={() => [this.getCropData("bannerImage"),this.formValChange({target:{name:'banner',value:'1'}})]}
                  >
                    Crop Image
                  </a>
                  &nbsp;&nbsp;&nbsp;
                  <a style={{
                    display:
                      this.state.bannerPreview == true && this.state.bannerCropData != "#"
                        ? "none"
                        : "inline-flex",
                  }}
                    className="button"
                    onClick={() => this.clearCropdata("bannerImage")}// this.formValChange({target:{name:'banner',value:'0'}})]}
                  >
                    Reset
                  </a>
                </h1>
                <p className="error">
                          {this.bannerImageName}
                </p> 
              </div>
              <div className="edit-profile__form">
                <div className="form-group">
                  <label>
                    Display Name <span className="asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter your display name"
                    readOnly={this.state.isSaving}
                    value={this.state.user_name}
                    name="user_name"
                    onChange={(e) => {
                      this.handleChange({
                        target: {
                          name: e.target.name,
                          value: e.target.value,
                        },
                      });
                    }}
                  />
                   <p className="error">
                          {this.dName}
                      </p> 
                </div>
                {/* <div className="form-group">
                  <label>Custom URL</label>
                  <div className="form-control__wrapp">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter your custom URL"
                      style={{ paddingLeft: "140px" }}
                      value={this.state.custom_url}
                      name="custom_url"
                      onChange={(e) => {
                        this.handleChange({
                          target: {
                            name: e.target.name,
                            value: e.target.value,
                          },
                        });
                      }}
                    />
                  </div>
                </div> */}
                <div className="form-group">
                  <label>Bio</label>
                  <div className="form-control__wrapp">
                    <textarea
                      className="form-control textarea"
                      placeholder="Enter a detailed description about yourself"
                      value={this.state.bio}
                      readOnly={this.state.isSaving}
                      name="bio"
                      onChange={(e) => {
                        this.handleChange({
                          target: {
                            name: e.target.name,
                            value: e.target.value,
                          },
                        });
                      }}
                    ></textarea>
                  </div>
                </div>
                <div className="form-group">
                  <label>Twitter Username</label>
                  <div className="form-control__wrapp">
                    <span>@</span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter your custom URL"
                      style={{ paddingLeft: "40px" }}
                      value={this.state.twitter_profile}
                      readOnly={this.state.isSaving}
                      name="twitter_profile"
                      onChange={(e) => {
                        this.handleChange({
                          target: {
                            name: e.target.name,
                            value: e.target.value,
                          },
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label>Personal Website URL</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="https://www.yoursite.io/"
                    value={this.state.personal_website}
                    readOnly={this.state.isSaving}
                    name="personal_website"
                    onChange={(e) => {
                      this.handleChange({
                        target: {
                          name: e.target.name,
                          value: e.target.value,
                        },
                      });
                    }}
                  />
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter your email"
                    value={this.state.email}
                    readOnly={this.state.isSaving}
                    name="email"
                    onChange={(e) => {
                      this.handleChange({
                        target: {
                          name: e.target.name,
                          value: e.target.value,
                        },
                      });
                    }}
                  />
                </div>
                <div className="form-group__varification">
                  <div className="form-group__varification-txt">
                    <h3>Verification</h3>
                    <p>
                      Proceed with verification process to get more visbility
                      and increase credibility on RedShilliz. This process may
                      take upto xyz number of days.
                    </p>
                    <a className="button purple-outline">Get Verified</a>
                  </div>
                </div>
                {this.state.isSaving ? (
                <div className="form-group__btn">
                  <div className="button btn-waiting ">
                      <img
                        className="loader"
                        src="../Loader/redshilliz-loader.gif "
                        alt="Coin"
                      />
                      Updating...
                    </div>
                 
                </div>
                ) : (
                  <div className="form-group__btn">
                     <a className="button" onClick={() => this.onSubmit()}>
                    Save Changes
                  </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </>
    );
  };
}
